import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as styles from './Stat.scss';

var Stat = /*#__PURE__*/function (_Component) {
  _inherits(Stat, _Component);

  var _super = _createSuper(Stat);

  function Stat() {
    _classCallCheck(this, Stat);

    return _super.apply(this, arguments);
  }

  _createClass(Stat, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          topText = _this$props.topText,
          bottomText = _this$props.bottomText,
          bottomTextColor = _this$props.bottomTextColor,
          topTextColor = _this$props.topTextColor,
          size = _this$props.size,
          theme = _this$props.theme;
      var top_text_color = topTextColor === 'primaryColor' || topTextColor === 'secondaryColor' ? theme.colors[topTextColor] : topTextColor;
      return /*#__PURE__*/React.createElement("div", {
        style: this.props.style,
        className: styles.statWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles[size]
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.topText,
        style: {
          color: top_text_color
        }
      }, topText), /*#__PURE__*/React.createElement("span", {
        className: styles.bottomText,
        style: {
          color: bottomTextColor
        }
      }, bottomText)));
    }
  }]);

  return Stat;
}(Component);

_defineProperty(Stat, "propTypes", {
  topText: PropTypes.string.isRequired,
  bottomText: PropTypes.string.isRequired,
  topTextColor: PropTypes.string,
  bottomTextColor: PropTypes.string,
  size: PropTypes.string,
  style: PropTypes.object
});

_defineProperty(Stat, "defaultProps", {
  topTextColor: 'primaryColor',
  size: 'medium',
  style: {}
});

export default Stat;